const content = {
    name: "content",
    path: "/content",
    title: "content",
    description: "Utilities for controlling the CSS `content` property, mainly used with pseudo-elements.",
    value: {
        "content": {
            "content-[<value>]": "<value>",
            "content-none": "none"
        }
    },
    exampleData: [
        {
            example: {
                code: `
<span class="after:content-[_↗]">Text</span>
        `
            }
        }
    ],
    htmlData: [
        {
            data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">content-[<value>]</code> to set custom content for pseudo-elements, or <code class="text-color-gray-800 dark:text-color-white font-semibold">content-none</code> to remove it.
      </p>
      <div class="space-y-6">
        <div class="max-w-md">
          <p>Higher resolution means more than just a better-quality image. With a
Retina 6K display, <b class="text-color-blue-600 after:content-[_↗]">
Pro Display XDR</b> gives you nearly 40 percent more screen real estate than
a 5K display.</p>
        </div>
      </div>
      `
        }
    ]
};

export default content;
<div className="text-color-blue-600 after:content-[_↗] before:content-none after:content-none sr-only"></div>